import { useState } from 'react';
import { useTranslation } from "react-i18next";
import './passcodeLogin.scss';
import LoginErrorComponent from '../loginError/loginError';

interface IPasscodeLoginComponentPorps {
    loginError: string;
    doLogin: (values: any) => void;
    loading?: boolean;
}

const PasscodeLoginComponent = (props: IPasscodeLoginComponentPorps) => {
    const { t } = useTranslation('browser');
    const [passwordValue, setPasswordValue] = useState('');
    const [checkboxValue, setCheckboxValue] = useState(false);
    const onLoginClick = () => {
        props.doLogin({
            password: passwordValue,
            remember: checkboxValue
        })
    };

    return (
        <div className="passcode-login-component-container">
            <div className="login-form">
                <p>{t('LOGIN_PASSCODE')}</p>
                <div className='passcode-input'></div>
                <input 
                    className="ctx-input" 
                    required 
                    type="password" 
                    placeholder='' 
                    value={passwordValue} 
                    onChange={(e) => setPasswordValue(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            onLoginClick();
                        }
                    }}
                />
                <input 
                    type="checkbox" 
                    id="passcodeLoginCheckbox" 
                    checked={checkboxValue} 
                    onChange={e => setCheckboxValue(e.target.checked)}
                />
                <label htmlFor="passcodeLoginCheckbox">{ t('LOGIN_REMEMBERME') }</label>
                {
                    props?.loginError && <LoginErrorComponent errMessage={ props.loginError } />
                }
                <button
                    className={`${(passwordValue && !props?.loading) ? 'ctx-button-active' : 'ctx-button-disabled'} button submit-btn login-button ctx-button`}
                    disabled={!passwordValue || props?.loading}
                    onClick={onLoginClick}>
                        {props?.loading ? <img src="/media/ctx-spinner.gif" alt="" className='button-loading-icon' /> : t('LOGIN_BUTTON')}
                </button>
            </div>
                <div id="recaptcha-container"></div>
        </div>
    )
}

export default PasscodeLoginComponent;